import React from "react";
import Modals from "../popupModal/modal";
import Button from "../../formElements/button/Button";
import { useHistory } from "react-router";
import { APPOINTMENT_REMINDER, getDashboardPath } from "../../../constants";

const ReminderModal = ({ openModal, setOpenModal }) => {
  const history = useHistory();

  return (
    <Modals
      isOpen={openModal}
      onRequestClose={() => setOpenModal(!openModal)}
      title="Reminder"
      styles={{
        content: {
          minWidth: "500px",
          maxWidth: "800px",
        },
      }}
    >
      <>
        <button
          onClick={() => setOpenModal(!openModal)}
          className="close modalCloseBtn"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>

        <p className="mx-auto mt-3 content-center">
          <img src={APPOINTMENT_REMINDER} alt="appointment_reminder" />
        </p>
        <p style={{ marginTop: "20px" }} className="text-center">
          You have an appointment in next 10 minutes
        </p>
        <p className="mx-auto w-75 mb-0">
          <Button
            label="Go to the Appointment"
            onClick={() => {
              setOpenModal(!openModal);
              history.push(getDashboardPath("/appointments/scheduled"));
            }}
          />
        </p>
      </>
    </Modals>
  );
};

export default ReminderModal;
